import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap4-modal';

import * as service from './../../../../Service/service';

class AddressProofModal extends Component {

    state = {
        imagePreview: '',
        file: '',
        isSelected: false,
        isUploaded: false,
        uploadData: {},
        documentSelected: '',
        documentError: false
    }

    clearSelected = () => {
        this.setState({
            ...this.state,
            imagePreview: '',
            file: '',
            isSelected: false,
            isUploaded: false,
            uploadData: {},
            documentSelected: '',
            documentError: false
        });
    }

    onBackdropClick = () => {
        this.setState({
            ...this.state,
            imagePreview: '',
            file: '',
            isSelected: false,
            isUploaded: false,
            uploadData: {},
            documentSelected: ''
        });
        this.props.hideAddressProofModal();
    }
    onFileSelect = (e) => {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({
                ...this.state,
                imagePreview: reader.result,
                file: file,
                isSelected: true
            });
        };
        reader.readAsDataURL(file);
    };

    uploadFile = () => {
        const formData = new FormData();
        formData.append("file", this.state.file);
        formData.append("documentType", "AADHAR_CARD");

        console.log(formData);

        service.uploadDocument(formData).then((response) => {
            this.setState({
                ...this.state,
                isUploaded: true,
                uploadData: response.data
            })
        }, (error) => {
            console.log(error);
        });
    }

    render() {
        return (
            <Modal visible={this.props.kyc.showAddressProofModal} onClickBackdrop={this.onBackdropClick}>
                <div className="modal-header">
                    <h5 className="modal-title">Upload Aadhar Card</h5>
                </div>
                <div className="modal-body pt-0 pb-0" style={{ height: 'inherit' }}>
                    <div className="row" style={{ minHeight: '250px' }}>
                        <div className="col-12 m-auto">
                            <div className="row mt-2">
                                {
                                    this.state.isUploaded && this.state.isSelected && (
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-12 text-center">
                                                    <h5>Thank you for uploading document.</h5>
                                                    <span className="text-black-50">*It may take some time to verify documents.</span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    !this.state.isSelected && (
                                        <div className="col-12 text-center mt-5 image-upload">
                                            <label htmlFor="file-input-document" className="cursor-pointer">
                                                <img alt="inputDocument" height="100px" src="./svg/uploadFile.svg" />
                                            </label>

                                            <input onChange={this.onFileSelect} id="file-input-document" type="file" name="pancard" />

                                            <h5 className="mt-3">Select Document File</h5>
                                            <span className="text-black-50">*( Allowed formats PDF, JPEG, PNG)</span>
                                        </div>
                                    )
                                }

                                {
                                    this.state.isSelected && !this.state.isUploaded && (
                                        <div className="col-12 text-center" style={{ maxHeight: '300px', overflowY: 'scroll' }}>
                                            <img className="img-fluid" src={this.state.imagePreview} alt="" />
                                        </div>
                                    )
                                }

                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" onClick={this.uploadFile} className="btn btn-primary btn-sm" >Upload Document</button>
                    <button type="button" onClick={this.clearSelected} className="btn btn-light btn-sm" >Clear Selection</button>
                    <button type="button" onClick={this.onBackdropClick} className="btn btn-danger btn-sm" >Cancel</button>
                </div>
            </Modal>
        );
    }
}


const mapStateToProps = (currentState) => {
    return {
        kyc: currentState.kyc,
    };
};

const mapActionsToProps = (dispatch) => {
    return {
        hideAddressProofModal: () => {
            dispatch({ type: 'kyc.addressProof.hide' });
        }
    };
}

export default connect(mapStateToProps, mapActionsToProps)(AddressProofModal);